import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy `/admin/org` entry point. Org administration now lives in the in-app
 * Manage console at /manage — redirect there. */
export const Route = createFileRoute("/_app/admin/org")({
  beforeLoad: () => {
    throw redirect({ to: "/manage" });
  },
});
